import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";

//typeing 애니메이션
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

function SubHead({ title = "윤리경영", eng = "Ethical Management" }) {
    useEffect(() => {
        Splitting();
    }, []);

    return (
        <article className="sub-header">
            <ul className="navigation">
                <li className="home">홈</li>
                <li>윤리경영</li>
                <li>{title}</li>
            </ul>

            <section className="sub-header-nav">
                <div className="names">
                    <h2>{eng}</h2>
                    <h3>{title}</h3>
                </div>

                <nav>
                    <ul className="snb">
                        {/* 클래스 on 추가 시 색 변경 */}
                        <li>
                            <NavLink to="/management/management" className={({ isActive }) => (isActive ? "on" : "")}>
                                윤리경영
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/management/anticorruption" className={({ isActive }) => (isActive ? "on" : "")}>
                                부패방지
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </section>

            <section className="sub-header-visual">
                <div className="inner management">
                    <h2>{eng}</h2>
                    <h3 data-splitting="chars">{title}</h3>
                    <p>
                        앞선 기술과 품질로 최고의 네트워크 서비스를 제공합니다. <br />
                        Global NO.1 Network Service Company
                    </p>
                </div>
            </section>
        </article>
    );
}

export default SubHead;
